
import React, { useState, useEffect, useCallback } from 'react';
import { Container, ButtonGroup, Button, Modal, Alert, Image } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import debounce from 'lodash.debounce';
import { ReactComponent as ArrowUpRight } from '../../static/images/svg/Arrow up right.svg';
import { ReactComponent as Trash } from '../../static/images/svg/Trash.svg';
import DetailsTable from '../../components/table';
import Footer from '../../components/footer';
import PaymentOffCanvasComp from '../../components/offcanvas/payment-offcanva';
import SpinnerComp from '../../components/spinner';
import Filters from '../../components/date-and-vendor-filter/index'; 
import DateFilter from '../../components/datefilter/index'; 
import { FaRegMoneyBill1 } from "react-icons/fa6";
import './today-analytics.css'
import ImageUpload from '../../components/shipment-status-form-canva/image-upload'

import CustomButton from '../../components/button';

function AllShipments({ user, isAnalytics=false }) {
  const [filterStatus, setFilterStatus] = useState('');
  const [filterStatusSm, setFilterStatusSm] = useState('');

  const [orderItems, setOrderItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [orderItem, setOrderItem] = useState();
  const [showModal, setShowModal] = useState(false);
  const [transactionToPay, setTransactionToPay] = useState(null);
  const [totalItem, setTotalItem] = useState();

  // New State for Filters
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [vendors, setVendors] = useState([]); // Populate this from an API or static data
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedVendorId, setSelectedVendorId] = useState(null);

    // Modal State
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false); // State to manage loader/progress
  const pageSize = 8;

  const fetchTransection = useCallback(
    debounce(async (filterStatusSm, currentPage) => {
      let isEror = false
      try {
        if (fromDate && !toDate) {
          toast.warn("To Date is missing.")
          isEror=true
        }if (!fromDate && toDate) {
          toast.warn("From Date is missing.")
          isEror=true
        }
        if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {          
          toast.error("To Date cannot be earlier than From Date.")
          isEror=true
        }
        
        if (toDate && new Date().toLocaleString('en-GB', { timeZone: 'Asia/Dubai' }) < new Date(toDate)) {
          toast.error("To Date cannot be later than current Date.")
          isEror=true
        }
        if (!isEror) {
          setLoading(true);        
        const response = await axios.post(
          `${process.env.REACT_APP_DEV_BACKEND_URL}/transection/get`,
          {
            status: filterStatusSm,
            fromDate: fromDate || null,
            toDate: toDate || null,
            vendorId: selectedVendorId,
            page: currentPage,
            pageSize,
          },
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        
        
        if (response.status === 200) {          
          const { transaction, pagination } = response.data;
            setOrderItems(transaction);
            setFilteredItems(transaction);
            setTotalPages(pagination.totalPages);
            setTotalItem(pagination.totalItems)

          }
        }
        
      } catch (error) {
        toast.error('Failed to fetch shipments!');
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }, 1000),
    [fromDate, toDate, selectedVendorId]
  );

  useEffect(() => {
    fetchTransection(filterStatusSm, currentPage);
    if (user.role === "admin") {
      fetchVendors();
    }
  }, [ filterStatusSm, currentPage, fetchTransection]);


  const fetchVendors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/users/all-user`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: { status: "active", role: "vendor" },

        }
      );
      
      setVendors(response.data.sellers.map((sellers) => ({ value: sellers._id, label: sellers.name })));
      
    } catch (err) {
      console.error("Error fetching vendors:", err);
    }
  };


  const handleFilter = (status) => {
    
    setFilterStatus(status);
    setCurrentPage(1); // Reset to first page on filter change
  };


  const handleFilterSm = (status) => {
    
    setFilterStatusSm(status);
    setCurrentPage(1); // Reset to first page on filter change
  };

  const handleReset = () => {
    setFilterStatus("")
    setFilterStatusSm("")
    setFromDate('');
    setToDate('');
    setSelectedVendor(null);
    setSelectedVendorId(null);
    fetchTransection( '', 1); // Reset filters and reload data
  };

  const handlePayNow = (item) => {
    setTransactionToPay(item._id);
    setShowModal(true);
  };

  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

  const handleImageUpload = async () => {    
    if (!selectedFile) {
      toast.error("Please select a file before submitting.");
      return;
    }
    const toPay = transactionToPay || 0
    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("status", "Paid");

    try {
      setUploading(true); // Show loader and freeze the screen
      // Dummy API call for image upload
      const response = await axios.post(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/transection/${transactionToPay}/status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );      
      toast.success("Status updated successfully!");
      setShowModal(false);
      setSelectedFile(null);
      fetchTransection(filterStatusSm, currentPage)
    } catch (error) {
      setSelectedFile(null);
      toast.error("Failed to upload image. Please try again.");
    }finally {
      setUploading(false); // Hide loader
    }
  };
  const cancel = ()=>{
    setShowModal(false)
    setSelectedFile(null);

  }

  const columns = [
    {
        header: 'Receipt',
        width: '5rem',
        render: (item) => (
            <div className="row align-items-center">
                <div className="col-auto pe-0">
                    <Image src={item.image} alt="" className='table-product-img' />
                </div>
                <div className="col">
                    <span>{item.description}</span>
                </div>
            </div>
        ),
    },
    {
        header: 'Amount',
        render: (item) =>"AED "+ item.toPay
    },
    {
        header: 'Status',
        render: (item) => item.status
    },
    {
        header: 'Merchant',
        render: (item) => item.vendor.name
    },
    {
        header: 'Date',
        render: (item) => new Date(item.updatedAt).toLocaleString('en-GB', { timeZone: 'Asia/Dubai' }),
      },
    {
        header: 'Action',
        render: (item) => (
          <div className="d-flex justify-content-center align-items-center gap-4">
            {user.role == 'admin' && (
              <CustomButton
              isDisabled={item.status !== 'Unpaid'} // Disable the button when status is not 'pending'
              variant="success"
              onClick={() => handlePayNow(item)}
            >
              <FaRegMoneyBill1 className="me-2" /> {/* Example Trash Icon */}
              <div className="ml-2">Pay Now</div>
            </CustomButton>
            )}
            <ArrowUpRight onClick={() => handleButtonClick(item)}style={{ cursor: 'pointer' }} />

          </div>
        ),
      },
]

	const handleButtonClick = (item) => {
		setOrderItem(item)
		setShow(true)
	}


  return (
    <>
      {loading ? (
        <SpinnerComp />
      ) : (
        <Container fluid className="px-4 bg-light p-4" style={{minHeight:"92vh"}}>
          <h2 style={{ color: '#005A9C' }}>All Transections</h2>
          <ToastContainer/>
          <br/>
          {!isAnalytics && (
            user.role === "admin" ? (
              <Filters
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                vendors={vendors}
                selectedVendor={selectedVendor}
                setSelectedVendor={setSelectedVendor}
                selectedVendorId={selectedVendorId}
                setSelectedVendorId={setSelectedVendorId}
                handleFilter={handleFilter}
                handleReset={handleReset}
                isAdmin={user.role === 'admin'}
                showApplyButton={false}
                isRider={false}
              />
            ) : (
              <DateFilter
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                handleFilter={handleFilter}
                handleReset={handleReset}
                showApplyButton={false}
              />
            )
          )}

          <div className="my-3">
            <ButtonGroup className="d-none d-sm-flex"> {/* Default horizontal layout for larger screens */}
              {['All', 'Paid', 'Unpaid'].map((status) => (
                <Button
                  key={status}
                  variant={filterStatusSm === status ? 'primary' : 'outline-primary'}
                  onClick={() => handleFilterSm(status === 'All' ? '' : status)}
                >
                  {status}
                </Button>
              ))}
            </ButtonGroup>
            <div className="d-flex d-sm-none flex-column gap-2"> {/* Stacked layout for smaller screens */}
              {['All', 'Paid', 'Unpaid'].map((status) => (
                <Button
                  key={status}
                  variant={filterStatusSm === status ? 'primary' : 'outline-primary'}
                  onClick={() => handleFilterSm(status === 'All' ? '' : status)}
                >
                  {status}
                </Button>
              ))}
            </div>
          </div>

          <br/>
          <div className="border " style={{ height: '33rem', overflowY: 'auto' }}>
            {filteredItems.length === 0 ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
              <Alert className="text-center" style={{ width: '50%', backgroundColor:"#005A9C", color:"white"}}>
                No Transaction found.
              </Alert>
              </div>
            ) : (
              <DetailsTable isTransparent={true} data={filteredItems} columns={columns} />
            )}
          </div>
          <Footer
            className={'d-flex justify-content-between align-items-center pt-3'}
            text={`${totalItem} Total Count`}
            pageSize={pageSize}
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </Container>
      )}

      {show && (
        <PaymentOffCanvasComp
          placement={'end'}
          show={show}
          setShow={setShow}
          orderItem={orderItem}
          name={user.name}
          token={user.token}
          role={user.role}
        />
        
      )}

      {/* Modal for Image Upload */}
      <Modal show={showModal}  centered>
        <Modal.Header >
          <Modal.Title>Upload Payment Proof</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {uploading ? (
            <div  id="progress-container">
              <p>Uploading, please wait...</p>
              <div id="progress-bar">
                <div id="progress"></div>
              </div>
            </div>
          ) : (
            <ImageUpload handleChange={handleFileChange} />
          )}
        </Modal.Body>
        <Modal.Footer>
          {!uploading && <CustomButton variant="danger" onClick={cancel} >
            Cancel
          </CustomButton>}
          {!uploading && <CustomButton variant="primary" onClick={handleImageUpload} >
            Submit
          </CustomButton>}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AllShipments;
